<div class="personal-infomation p-4 mt-4">
    <div class=" d-flex justify-content-between ">
        <h2 class="profile-heading">About You</h2>
        <img class="edit-profile " *ngIf="!showEditForm" alt="" src="../../assets/images/editprofile.svg" (click)="editAboutYou()" id="edit-icon2">

    </div>
   <div *ngIf="!showEditForm">
    <div class="mt-1">
        <p  class="label" [innerHTML]="aboutId.get('about')?.value"></p>
    </div>
    <div id="social-media-links">
    <div class="mt-1">
        <h4 class="profile-h4">Social Media Links</h4>
    </div>
    <div class="mt-2 d-flex">
        <div class="social-media-border mx-1" *ngIf="aboutId.get('facebookUrl')?.value" (click)="openUrl(aboutId.get('facebookUrl')?.value)">
            <img  src="../../assets/images/FacebookAppSymbol.svg"  alt="" srcset="">

        </div>
        <div class="social-media-border mx-1" *ngIf="aboutId.get('twitterUrl')?.value" (click)="openUrl(aboutId.get('twitterUrl')?.value)">
            <img  src="../../assets/images/Twitter.svg" alt="" srcset="">

        </div>
        <div class="social-media-border mx-1" *ngIf="aboutId.get('linkedin')?.value" (click)="openUrl(aboutId.get('linkedin')?.value)">
            <img  src="../../assets/images/LinkedinLogo.svg" alt="" srcset="">

        </div>
        <div class="social-media-border mx-1" *ngIf="aboutId.get('instagramUrl')?.value" (click)="openUrl(aboutId.get('instagramUrl')?.value)">
            <img  src="../../assets/images/Instagram.svg" alt="" srcset="">

        </div>
    </div>
</div>
   </div>
   <div *ngIf="showEditForm" class="mt-2">
    <form [formGroup]="aboutYouForm">
        <div formGroupName="aboutId">
            <div class="row">
                <div class="col-lg-12">
                    <div>
                        <angular-editor [config]="editorConfig" formControlName="about" ></angular-editor>
                        <div *ngIf="isWordLimitExceeded" class="warning-text">
                          {{ warningMessage }}
                        </div>
                        <div *ngIf="!isWordLimitExceeded" class="warning-text" style="margin-left: 5px;">                            
                            Maximum: 255 words, Remaining: {{ remainingWords }} words
                          </div>
                      </div>
                </div>
            </div>
            <div class="row mt-4">
                <h4 class="profile-h4 profile-h4__color">Social Media Links</h4>
                <div class="col-lg-6 profileurl">
                    <div >
                        <p class="profile-h4 profile-h4__font-Weight-medium  profile-h4__color m-0">Facebook URL</p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font  w-100 mt-1">
                            <input matInput  formControlName="facebookUrl" placeholder="Enter Valid facebookUrl">
                             <mat-error class="error-message error-msg facebook-error" *ngIf="aboutId.get('facebookUrl')?.hasError('pattern') || aboutId.get('facebookUrl')?.hasError('maxlength')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                {{aboutId.get('facebookUrl')?.hasError('pattern') ? 'Please enter a valid URL that starts with "http","https" or "www."' : 
                                'Limit Exceeded:Max 255 characters'}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-6 profileurl">
                    <div >
                        <p class="profile-h4 profile-h4__font-Weight-medium  profile-h4__color m-0">Twitter URL </p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font  w-100  mt-1">
                            <input matInput  formControlName="twitterUrl" placeholder="Enter Valid twitterURL">
                            <mat-error class="error-message error-msg twitter-error" *ngIf="aboutId.get('twitterUrl')?.hasError('pattern') || aboutId.get('twitterUrl')?.hasError('maxlength')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                {{aboutId.get('twitterUrl')?.hasError('pattern') ? 'Please enter a valid URL that starts with "http","https" or "www."' : 
                                'Limit Exceeded:Max 255 characters'}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 profileurl">
                    <div >
                        <p class="profile-h4 profile-h4__font-Weight-medium  profile-h4__color m-0  ">LinkedIn URL</p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font  w-100  mt-1">
                            <input matInput  formControlName="linkedin" placeholder="Enter Valid linkedinURL">
                              <mat-error class="error-message error-msg linkedin-error" *ngIf="aboutId.get('linkedin')?.hasError('pattern') || aboutId.get('linkedin')?.hasError('maxlength')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                {{aboutId.get('linkedin')?.hasError('pattern') ? 'Please enter a valid URL that starts with "http","https" or "www."' : 
                                'Limit Exceeded:Max 255 characters'}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div >
                        <p class="profile-h4 profile-h4__font-Weight-medium  profile-h4__color m-0">Instagram URL</p>
                    </div>
                    <div>
                        <mat-form-field appearance="outline" class="input-font  w-100 mt-1">
                            <input matInput  formControlName="instagramUrl" placeholder="Enter Valid instagramURL">
                            <mat-error class="error-message error-msg linkedin-error" *ngIf="aboutId.get('instagramUrl')?.hasError('pattern') || aboutId.get('instagramUrl')?.hasError('maxlength')">
                                <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                                {{aboutId.get('instagramUrl')?.hasError('pattern') ? 'Please enter a valid URL that starts with "http","https" or "www."' : 
                                'Limit Exceeded:Max 255 characters'}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </form>
    
   </div>
   <div class="profile-action " *ngIf="showEditForm">       
    <button  class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3" (click)="update()">Update</button>  
    <button  class="mwe-button mwe-button--secondary ps-3 pe-3" (click)="cancel()">Cancel</button>
</div>
</div>